// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {Sequence} from 'components/Sequence';
import * as CrisprConstants from 'constants/CRISPRConstants';
import notifications from 'notifications';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import EditsTable from './EditsTable';
import HRTemplateActions from './HRTemplateActions';

const {HR_TEMPLATE_STEP, MINIMUM_HR_TEMPLATE_LENGTH, HR_TEMPLATE_TAB_ID} = CrisprConstants;

interface Props {
  sequence: Sequence;
  originalBases: string;
}

class IntroduceEditsStep extends React.Component<Props> {
  componentDidMount(): void {
    this.props.sequence.removeLockingTab(HR_TEMPLATE_TAB_ID);
  }

  render(): JSX.Element {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (this.props.sequence.length() < MINIMUM_HR_TEMPLATE_LENGTH) {
            notifications.error(`Your sequence is less than ${MINIMUM_HR_TEMPLATE_LENGTH} bp.`);
            return;
          }

          const savedVersions = _.object([
            [HR_TEMPLATE_STEP.SELECT_ARMS, this.props.sequence.getActiveVersionId()],
          ]);

          HRTemplateActions.serverUpdate(this.props.sequence.id, {
            step: HR_TEMPLATE_STEP.SELECT_ARMS,
            savedVersions,
          });
          analytics.track('hr_template', 'completed_step_introduce_edits');
        }}
      >
        <fieldset>
          <legend>Step 1: Introduce desired edits</legend>
          <div className="alert alert-info">
            <div className="u-small-spacing-bottom">
              <strong>
                {'Select and type in the sequence map to introduce the changes (e.g. point mutations, '}
                insertions, deletions) you want to make to the genome.
              </strong>
            </div>
            <div>
              <em>Silent mutations to remove the target site will be added in a later step.</em>
            </div>
          </div>
          <EditsTable
            originalBases={this.props.originalBases}
            currentBases={this.props.sequence.bases()}
            sequence={this.props.sequence}
          />
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.SMALL}
            className="pull-right"
            type="submit"
            text="Next"
          />
        </fieldset>
      </form>
    );
  }
}

export default IntroduceEditsStep;
